import * as React from 'react';

import { Tag } from '@coursera/cds-core';

import _t from 'i18n!nls/product-card';

export type TrendingNowPillVariant = 'none' | 'gradient-background' | 'solid-background';

// MERCH-3316: dedicated slug list for the "Trending now" pill test.
// https://docs.google.com/spreadsheets/d/1AxnjBpMUYKKOasHHWH00r9uYv5Ef7O8lCBGJxDZERrg/edit?gid=219402167#gid=219402167
const TRENDING_NOW_PILL_SLUGS = new Set([
  'abnormal-psychology',
  'academic-english',
  'accounting-assistant',
  'adobe-graphic-designer',
  'adp-airs-entry-level-recruiter',
  'agile-atlassian-jira',
  'ai-financial-services-foundations-future-trends',
  'ai-for-finance',
  'algorithms',
  'american-english-pronunciation',
  'american-law',
  'anatomy',
  'anxiety-mood-substance-addictive-behaviors',
  'applied-data-science',
  'arizona-state-university-tesol',
  'aws-cloud-practitioner-essentials',
  'aws-cloud-solutions-architect',
  'aws-cloud-support-associate',
  'aws-cloud-technology-consultant',
  'backend-javascript-developer',
  'behavior-technician-aba-fundamentals',
  'bi-analyst',
  'biostatistics-public-health',
  'boulder-data-structures-algorithms',
  'branding-the-creative-journey',
  'build-high-performing-teams',
  'business-communication',
  'business-financial-management',
  'business-management-essentials',
  'business-statistics-analysis',
  'c-programming',
  'cancer-biology',
  'canva-essentials',
  'career-success',
  'careerdevelopment',
  'cbrops',
  'cissp',
  'cloud-engineering-gcp',
  'coding-for-everyone',
  'computational-neuroscience',
  'creative-design-tools-adobe-photoshop-illustrator-acrobat',
  'creative-writing',
  'data-science-fundamentals-python-sql',
  'data-skills-for-excel',
  'data-structures-algorithms',
  'devops-and-software-engineering',
  'digital-manufacturing-design-technology',
  'digitalhealth',
  'discrete-mathematics',
  'drug-development-and-pharmacoepidemiology',
  'electrified-systems-design-engineer',
  'english-intermediate-b1',
  'epic-games-game-design-professional-certificate',
  'everyday-excel',
  'excel',
  'excel-data-analytics-visualization',
  'excel-essentials',
  'facebook-marketing-analytics',
  'filmmaking',
  'finance-accounting',
  'finance-quantitative-modeling-analysts',
  'financial-analyst-ai-excel-and-power-bi-skills',
  'financial-markets-global',
  'financialengineering',
  'financialtechnology',
  'food-and-health',
  'foundations-of-cybersecurity',
  'foundations-of-digital-marketing-and-e-commerce',
  'fpga-design',
  'french-beginner',
  'game-design',
  'generative-ai-data-analyst',
  'generative-ai-for-ui-ux-design',
  'genomic-data-science',
  'gis',
  'gis-mapping-spatial-analysis',
  'global-affairs-explained',
  'goodwill-career-coach-and-navigator',
  'google-advanced-data-analytics',
  'google-business-intelligence',
  'google-cloud-cybersecurity-certificate',
  'google-data-analysis-with-python',
  'graphic-design',
  'health-informatics',
  'healthcare-law',
  'high-performance-leadership',
  'hrci-human-resource-associate-international',
  'human-anatomy-medical-terminology-fundamentals',
  'ibm-backend-development',
  'ibm-data-manager',
  'ibm-data-science',
  'ibm-deep-learning-with-pytorch-keras-tensorflow',
  'ibm-full-stack-javascript-developer',
  'ibm-intro-machine-learning',
  'ibm-ios-android-mobile-app-developer-pc',
  'ibm-it-project-manager',
  'ibm-management-consultant',
  'ibm-relational-database-administrator',
  'ibm-systems-analyst',
  'ibm-ui-ux-designer',
  'immunology',
  'introduction-intellectual-property',
  'introduction-to-ai',
  'introduction-to-biology',
  'introduction-to-cosmetic-science',
  'introduction-to-learning-experience-design',
  'it-fundamentals-cybersecurity',
  'itil-v4-certification-preparation',
  'java-developer',
  'keller-williams-real-estate-agent',
  'lead-for-results-from-planning-to-execution',
  'leading-modern-day-business',
  'learn-sql-basics-data-science',
  'learning-how-to-learn',
  'mathematics-engineers',
  'matlab-programming-engineers-scientists',
  'mba',
  'medicalterminology',
  'meta-android-developer',
  'meta-community-management',
  'michiganux',
  'microsoft-365-essentials-create-collaborate-and-deliver',
  'microsoft-365-fundamentals',
  'microsoft-azure-ai-900-ai-fundamentals',
  'microsoft-azure-dp-900-data-fundamentals',
  'microsoft-business-analyst',
  'microsoft-data-architecture-for-modern-data-stacks',
  'microsoft-excel-skills',
  'microsoft-introduction-to-c-plus-plus-programming',
  'microsoft-it-support-specialist',
  'microsoft-power-bi-and-power-platform-productivity',
  'microsoft-power-platform-fundamentals',
  'microsoft-powerbi-developer-and-architect',
  'microsoft-python-developer',
  'modern-contemporary-art-design',
  'moral-politics',
  'music-business',
  'negotiation-skills',
  'neurobiology',
  'packt-cisco-ccna-200-301-the-complete-guide-to-getting-certified',
  'packt-comptia-security-plus-certification-sy0-701-the-total-course',
  'packt-docker-and-kubernetes-masterclass-from-beginner-to-advanced',
  'pearson-certified-associate-in-project-management-capm-exam',
  'pearson-pmp-certification',
  'personal-finance-fundamentals',
  'pharmacy-technician-fundamentals',
  'physiology',
  'positivepsychology',
  'postgresql-for-everybody',
  'principles-of-financial-leadership',
  'professional-epidemiology',
  'programming-python-java',
  'project-initiation-google',
  'project-management-and-planning',
  'project-management-foundations',
  'psychological-first-aid',
  'psychological-research',
  'psychology-in-everyday-life',
  'psychology-of-disorders-related-to-trauma-anxiety-and-stress',
  'public-speaking',
  'python',
  'renewable-energy',
  'risk-management',
  'sap-business-analyst',
  'sap-technology-consultant',
  'school-health-for-children-and-adolescents',
  'sciwrite',
  'six-sigma-green-belt',
  'software-quality-assurance-testing',
  'stanford-statistics',
  'statistical-analysis-r-public-health',
  'statistical-inference-for-data-science-applications',
  'strategic-management',
  'supply-chain-analytics',
  'supply-chain-management',
  'systematic-review',
  'tableau-business-intelligence-analyst',
  'tally-bookkeeper',
  'the-science-of-well-being',
  'unilever-digital-marketing-analyst',
  'unlock-business-insights-with-microsoft-excel-and-power-bi',
  'uol-business-and-marketing-strategies',
  'ux-design',
  'wharton-business-foundations',
  'workday-human-capital-management',
  'xbox-graphic-designer',
]);

export const isTrendingNowPillSlug = (slug: string): boolean => TRENDING_NOW_PILL_SLUGS.has(slug);

// MERCH-3316: hex/token values from the approved design.
// CDS's default hasIcon padding-inline-start (--cds-spacing-25, 2px) reads as too tight against
// this icon's own glyph, which — unlike AIGenerateIcon — has ink running close to its left edge.
// paddingLeft below overrides just that side to give the icon breathing room from the pill border.
const trendingNowPillVariantStyle: Record<'gradient-background' | 'solid-background', React.CSSProperties> = {
  'gradient-background': {
    background:
      'linear-gradient(90deg, var(--MDS-3-Expressive-Yellow-Yellow-500-AA, #D65D00) -9.21%, var(--MDS-3-Expressive-Pink-Pink-700-AAA, #9C1A84) 100%)',
    color: 'var(--cds-color-neutral-primary-invert)',
    border: 'none',
    paddingTop: '1px',
    paddingBottom: '1px',
    paddingLeft: 'var(--cds-spacing-75)',
  },
  'solid-background': {
    backgroundColor: 'var(--cds-color-feedback-background-error-weak)',
    color: 'var(--cds-color-feedback-error)',
    border: 'none',
    paddingTop: '1px',
    paddingBottom: '1px',
    paddingLeft: 'var(--cds-spacing-75)',
  },
};

// Uses `fill="currentColor"` so the icon always matches the pill's own text color, set above.
const TrendingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path
      d="M2.03383 12.2833C1.9116 12.1611 1.84771 12.0194 1.84216 11.8583C1.8366 11.6972 1.89494 11.5556 2.01716 11.4333L5.43383 8.01667C5.66716 7.78334 5.95049 7.66667 6.28383 7.66667C6.61716 7.66667 6.90049 7.78334 7.13383 8.01667L8.81716 9.7L12.3505 6.18334H11.0005C10.8305 6.18334 10.688 6.12617 10.573 6.01184C10.458 5.8975 10.4005 5.75584 10.4005 5.58684C10.4005 5.41784 10.458 5.275 10.573 5.15834C10.688 5.04167 10.8305 4.98334 11.0005 4.98334H13.8005C13.9705 4.98334 14.113 5.04084 14.228 5.15584C14.343 5.27084 14.4005 5.41334 14.4005 5.58334V8.38334C14.4005 8.55334 14.3433 8.69584 14.229 8.81084C14.1147 8.92584 13.973 8.98334 13.804 8.98334C13.635 8.98334 13.4922 8.92745 13.3755 8.81567C13.2588 8.70378 13.2005 8.56523 13.2005 8.4V7.03334L9.66716 10.5667C9.43383 10.8 9.15049 10.9167 8.81716 10.9167C8.48383 10.9167 8.20049 10.8 7.96716 10.5667L6.28383 8.86667L2.88383 12.2833C2.7616 12.4056 2.61994 12.4667 2.45883 12.4667C2.29771 12.4667 2.15605 12.4056 2.03383 12.2833Z"
      fill="currentColor"
    />
  </svg>
);

export const getTrendingNowPillLabel = () => _t('Trending right now');

/**
 * Builds the "Trending right now" experimental status tag, including its pre-rendered pill, for the
 * given Statsig variant. Returns undefined when the variant is 'none'/unset — unlike the other
 * pill tests, there's no plain fallback rendering for this tag: the control group sees no pill
 * at all, since the test is about whether adding the pill helps, not which treatment is best.
 */
export const getTrendingNowExperimentalTag = (variant?: TrendingNowPillVariant) => {
  if (!variant || variant === 'none') {
    return undefined;
  }

  const tag = getTrendingNowPillLabel();

  return {
    tag,
    tagName: 'Trending right now',
    tagRenderer: (
      <Tag
        color="default"
        priority="secondary"
        variant="status"
        icon={<TrendingIcon />}
        style={trendingNowPillVariantStyle[variant]}
      >
        {tag}
      </Tag>
    ),
  };
};
